import { gql, Locale } from '@yi/core';
import { i18n_challenge } from '@yi/i18n/phrases/i18n_challenge';
import { i18n_course } from '@yi/i18n/phrases/i18n_course';
import { i18n_podcast } from '@yi/i18n/phrases/i18n_podcast';
import { i18n_premium_training } from '@yi/i18n/phrases/i18n_premium_training';

import { CourseType } from './types';

export const getCourseTypeLabel = (type: CourseType, locale: Locale) => {
  switch (type) {
    case gql.typesClient.CourseType.CHALLENGE:
      return i18n_challenge(locale);
    case gql.typesClient.CourseType.PODCAST:
      return i18n_podcast(locale);
    case gql.typesClient.CourseType.PREMIUM_TRAINING:
      return i18n_premium_training(locale);
    case gql.typesClient.CourseType.WORKSHOP:
      return i18n_course(locale);
    default:
      return i18n_course(locale);
  }
};
